import React, { Component, Fragment } from 'react'

class Slider extends Component {
     render() {
          return (
               <Fragment>
                     {/* <h1>CHRISALPHA TECH COMPANY LIMITED</h1> */}
               </Fragment>
          )
     }
}

export default Slider